import inperson from "../assets/img/inpersonW-24.png";
import telephone from "../assets/img/telephoneW-24.png";
import video from "../assets/img/videoW-24.png";

import complete from "../assets/img/doneW.png";
import offered from "../assets/img/offeredW.png";
import scheduled from "../assets/img/scheduledW.png";
import unscheduled from "../assets/img/unscheduledW.png";

export const determineStateIconColor = (state, action) => {
  const defaultColor = "primary";
  const apptState = state;
  const apptAct = action;

  switch (apptState) {
    case "SCHEDULED":
      return "success";
    case "COMPLETED":
      return "info";
    case "UNSCHEDULED":
      if (apptAct === "OFFERED") {
        return "warning";
      } else {
        return "danger";
      }
    default:
      return defaultColor;
  }
};
export const determineModalityIconColor = (modalityCode) => {
  const defaultColor = "primary";
  const modCode = modalityCode;
  switch (modCode) {
    case "VRI":
      return "info";
    case "IP":
      return "success";
    case "OPI":
      return "danger";

    default:
      return defaultColor;
  }
};
export const determineModalityIcon = (modalityCode) => {
  const modCode = modalityCode;

  switch (modCode) {
    case "VRI":
      return video;
    case "IP":
      return inperson;
    case "OPI":
      return telephone;

    default:
      return null;
  }
};

export const determineStateIcon = (state, action) => {
  const apptState = state;
  const apptAct = action;

  switch (apptState) {
    case "SCHEDULED":
      return scheduled;
    case "COMPLETED":
      return complete;
    case "UNSCHEDULED":
      if (apptAct === "OFFERED") {
        return offered;
      } else {
        return unscheduled;
      }
    default:
      return null;
  }
};
